import { ExpressionSpecification, FillLayerSpecification } from 'maplibre-gl';

import { AcresMapboxLayerIds, AcresMapboxSourceIds } from '..';

function getSoilLayer(colorFilter: any[]): FillLayerSpecification {
  const layer: FillLayerSpecification = {
    id: AcresMapboxLayerIds.SOIL,
    paint: {
      'fill-color': colorFilter as ExpressionSpecification,
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        1,
        0.5,
      ],
      'fill-outline-color': colorFilter as ExpressionSpecification,
    },
    source: AcresMapboxSourceIds.SOIL,
    type: 'fill',
  };

  return layer;
}

export default getSoilLayer;
